// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import CompanySetting from "entity/CompanySetting";
import UserSetting from "entity/UserSetting";

import { RestController, RestRequest } from "./RestController";

export default class SettingController extends RestController {

    /*
     Get user settings.
     */

    getCompanySettings(companyId: string): Promise<CompanySetting[]> {
        const request = new RestRequest("/api/v1/setting/company/" + companyId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<CompanySetting[]>;
    }

    /*
     Get user settings.
     */

    getSettings(): Promise<UserSetting[]> {
        const request = new RestRequest("/api/v1/setting", "GET", null, undefined);
        return this.request(request, null) as Promise<UserSetting[]>;
    }

    /*
     Save user setting.
     */

    saveCompanySetting(setting: CompanySetting): Promise<CompanySetting> {
        const request = new RestRequest("/api/v1/setting/company", "POST", setting, undefined);
        return this.request(request, null) as Promise<CompanySetting>;
    }

    /*
     Save user setting. Will be saved for current user.
     */

    saveSetting(setting: UserSetting): Promise<UserSetting> {
        const request = new RestRequest("/api/v1/setting", "POST", setting, undefined);
        return this.request(request, null) as Promise<UserSetting>;
    }

    /*
     Save user setting. Requires company admin privilege.
     */

    saveUserSetting(setting: UserSetting): Promise<UserSetting> {
        const request = new RestRequest("/api/v1/setting/user", "POST", setting, undefined);
        return this.request(request, null) as Promise<UserSetting>;
    }

}
